import type { MigrationManifest, PersistedState } from 'redux-persist';
import { v4 as uuidv4 } from 'uuid';

export const PERSIST_VERSION = 3;

type StoredRoot = NonNullable<PersistedState> & { quote?: unknown };

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

const hasText = (value: unknown): value is string => typeof value === 'string' && value !== '';

/** Never throws: a throwing migration makes redux-persist drop the whole stored root, device UUID included. */
const addDraftIdentity = (state: PersistedState): PersistedState => {
    const root = state as StoredRoot | undefined;
    if (!root || !isRecord(root.quote)) {
        return state;
    }
    const quote = { ...root.quote };
    delete quote.saveUnconfirmed;
    return {
        ...root,
        quote: {
            ...quote,
            draftId: hasText(quote.draftId) ? quote.draftId : uuidv4(),
            saveDirty: typeof quote.saveDirty === 'boolean' ? quote.saveDirty : false,
        },
    } as PersistedState;
};

const addAnchorDate = (state: PersistedState): PersistedState => {
    const root = state as StoredRoot | undefined;
    if (!root || !isRecord(root.quote)) {
        return state;
    }
    return {
        ...root,
        quote: { ...root.quote, anchorDate: 'anchorDate' in root.quote ? root.quote.anchorDate : null },
    } as PersistedState;
};

export const persistMigrations: MigrationManifest = {
    2: addDraftIdentity,
    3: addAnchorDate,
};
